import { Lead, LeadSource, LeadStatus } from '../../../../../models/Leads';

export const selectionLead = {
  status: LeadStatus.ON_HOLD,
  source: LeadSource.ORBIRENTAL_FORM,
} as Lead;
